var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"flex flex-col gap-4"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }